<template>
  <TransitionRoot :show="isOpen" as="template">
    <Dialog
      :open="isOpen"
      as="div"
      class="fixed inset-0 z-[1000] overflow-y-auto"
      static
    >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay
          class="fixed inset-0 backdrop-blur-[20px] transition-opacity"
        />
      </TransitionChild>

      <div class="flex h-screen items-center justify-center">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            :class="[maxWidth, hideOverflow ? 'overflow-hidden' : '']"
            class="my-auto flex w-full items-center justify-center px-4 py-10 md:px-5"
          >
            <BaseBoxWrapper
              :class="[maxWidth, paddingsClass]"
              class="inline-block w-full transform align-middle !shadow-md transition-all"
              theme="modal"
            >
              <button
                v-if="closeButton"
                class="transition-ease-in-out absolute -right-2 -top-5 flex h-10 w-10 items-center justify-center rounded-full border border-white bg-primary text-white hover:border-primary hover:bg-white hover:text-primary md:-right-5"
                @click="onClickClose"
              >
                <inline-svg :src="useAsset(`icons/base/close-modal.svg`)" />
              </button>

              <slot />
            </BaseBoxWrapper>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import InlineSvg from 'vue-inline-svg'
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import { useModalsStore } from '~~/stores/modals'

const modalsStore = useModalsStore()

const emits = defineEmits(['opened', 'closed', 'close'])
const props = defineProps({
  modalName: {
    type: [String],
    default: '',
  },
  maxWidth: {
    type: [String],
    default: '',
  },
  paddingsClass: {
    type: [String],
    default: 'px-4 py-10 md:px-8',
  },
  hideOverflow: {
    type: [Boolean],
    default: true,
  },
  closeButton: {
    type: [Boolean],
    default: true,
  },
})

const isOpen = computed(() => {
  return modalsStore.isOpenModal(props.modalName)
})

const onClickClose = () => {
  modalsStore.close(props.modalName)
  emits('close')
}

watch(isOpen, (newValue) => {
  if (newValue) {
    emits('opened')
  } else {
    emits('closed')
  }
})
</script>
